<template>
  <div class="">
    <div>
        <v-snackbar top right v-model="snackbar" :color="snackbar_color" :timeout="2000" >
          <span>{{message}}</span>
        </v-snackbar>
        <v-card class="neu-glow mt-5 mb-2">
          <v-card-title primary-title>
            <div class="text-h5">Moduli Disponibili</div>
            <v-spacer></v-spacer>
            <div>
              <!--
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading_update"  :disabled="items_hash==JSON.stringify(items)" @click.stop="saveItems()">
                    <v-icon color="error">mdi-content-save</v-icon>
                  </v-btn>
                </template>
                <span>Salva</span>
              </v-tooltip>
              -->
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_instruction=true">
                    <v-icon color="info">mdi-help-circle</v-icon>
                  </v-btn>
                </template>
                <span>Istruzioni</span>
              </v-tooltip>                
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading"  @click.stop="getData('refresh')">
                    <v-icon color="info">mdi-sync-circle</v-icon>
                  </v-btn>
                </template>
                <span>Refresh</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_simulator=true">
                    <v-icon color="info">mdi-calculator-variant</v-icon>
                  </v-btn>
                </template>
                <span>Stima Costi Variabili</span>
              </v-tooltip>                          
            </div>           
          </v-card-title>
          
            <v-row v-if="loading">
                <v-col class="text-center">
                  <v-progress-linear
                    color="info"
                    height="10"
                    indeterminate
                    striped
                  ></v-progress-linear>
                </v-col>
            </v-row>
            <div v-else class="mx-4">

              

            <v-row>
              <v-col v-for="(i,ii) in items.filter(i=>i.show==1)" :key="ii">
                <v-card class="neu-glow text-center">
                  <div class="pa-4 pl-0">
                    <v-card-text class="d-flex justify-end mt-n6 pr-0 mb-n14">
                      <v-btn small fab icon @click="videoId=i.videoId;dialog_video=true" :disabled="!i.videoId">
                        <v-icon color="info">mdi-video-box</v-icon>
                      </v-btn>
                    </v-card-text>
                    <v-card-text class="">
                      <v-icon :color="i.iconColor" class="text-center text-h3">{{i.icon}}</v-icon>
                    </v-card-text>
                    <v-card-text class="text-h5 py-1">
                      {{i.productName}}
                    </v-card-text>
                    <v-card-text class="py-1 d-flex justify-center align-center" style="min-heigth:52px">
                      {{i.description}}
                    </v-card-text>         
                    <v-card-text class="text-h5 py-1">
                      {{(i.price).toFixed(2)}} €
                    </v-card-text>
                    <div v-if="i.subtext">
                      {{i.subtext||'&nbsp;'}}
                    </div>
                    <!--
                    <v-card-text class="d-flex justify-center py-0">
                      <v-switch
                        v-model="i.active"
                        color="info"
                        :readonly="i.editable==false"
                        :disabled="i.bookable==false"
                      ></v-switch>                    
                    </v-card-text>  
                    <div v-if="!i.bookable" class="text-center pt-3">
                      In Arrivo
                    </div>
                    <div class="mt-3 ml-2" v-if="i.bookable">
                      <v-progress-linear
                        :color="i.duration>30?'success':'error'"
                        :value="i.duration/90*100"
                        height="25"
                        rounded
                      >
                        <template v-slot:default="{ value }">
                          <strong v-if="value+1">{{ i.duration }} gg.</strong>
                        </template>
                      </v-progress-linear>                    
                    </div>
                    
                    <v-card-actions class="d-flex justify-end">
                      <v-btn
                        icon fab small
                        color="info"
                        class="text-center"
                        @click="i.more=true"
                      >
                        <v-icon color="info">mdi-dots-horizontal</v-icon>
                      </v-btn>
                    </v-card-actions>                               
                    <v-expand-transition>
                      <v-card
                        v-if="i.more"
                        class="transition-fast-in-fast-out v-card--reveal neu-glow px-2"
                        style="height: 100%;"
                      >
                        <v-card-title>
                          <v-spacer></v-spacer>
                          <v-btn
                            icon fab small
                            color="info"
                            class="text-center"
                            @click="i.more=false"
                          >
                            <v-icon color="info">mdi-close-circle</v-icon>
                          </v-btn>
                        </v-card-title>
                        <v-card-text class="pb-0">
                          <p class="text-h4 ">
                            Costi a consumo
                          </p>
                          <p>{{i.details}}</p>
                          <template v-for="(c,ci) in servicesCosts">
                            <div v-if="i[c.costId]>0" :key="ci">
                              <v-row class="px-1 mt-6 neu-glow">
                                <v-col class="text-left ">{{c.name}} ({{c.um}})</v-col>
                                <v-col class="text-right col-auto">{{i[c.costId]}} €</v-col>
                              </v-row>
                            </div>
                          </template>
                        </v-card-text>
                      </v-card>
                    </v-expand-transition>
                    -->
                  </div>
                </v-card> 
              </v-col>
            </v-row>
            <v-divider class="my-5"></v-divider>
            <v-row>
              <v-col cols="12">
                <div class="text-h5 mb-2">
                  Dettaglio Moduli Attivi
                </div>
              </v-col>
            </v-row>

            <v-row v-for="(i,ii) in items.filter(i=>i.show==1)" :key="ii">
              <v-col cols="12">
                <v-card class="neu-glow" style="max-height:68px">
                  <v-row class="pa-0 ma-0">
                    <v-col style="max-height:60px">
                      <div class="float-left">                       
                        <v-icon :color="i.iconColor" class="text-center text-h3">{{i.icon}}</v-icon>                       
                      </div>
                      <div class="text-h5 pt-3 pl-3 float-left">
                        {{i.productName}}
                      </div>                                            
                    </v-col>
                    <v-col>                      
                      <div class="py-1">
                        {{i.description}}
                      </div>
                    </v-col>
                    <v-col>         
                      <div class="text-h5 py-1 text-right">
                        {{(i.price).toFixed(2)}} €
                      </div>
                      <div v-if="i.subtext" class="pt-4">
                        {{i.subtext||'&nbsp;'}}
                      </div>
                    </v-col>
                    <v-col>
                      <div v-if="!i.bookable" class="pt-3">
                        In Arrivo
                      </div>
                    </v-col>
                    <v-col>
                      <div class="mt-3" v-if="i.bookable">
                        <v-progress-linear
                          :color="i.duration>30?'success':'error'"
                          :value="i.duration/90*100"
                          height="25"
                          rounded
                        >
                          <template v-slot:default="{ value }">
                            <strong v-if="value+1">{{ i.duration }} gg.</strong>
                          </template>
                        </v-progress-linear>                    
                      </div>
                    </v-col>
                    <v-col>
                      <div class="d-flex justify-center py-0">
                        
                        <!--
                          v-if="servicesCosts.some(c=>{return selectedProduct[c.costId]>0})"
                        <v-btn fab icon @click="videoId=i.videoId;dialog_video=true" :disabled="!i.videoId" class="mr-6">
                          <v-icon color="info">mdi-video-box</v-icon>
                        </v-btn>
                        -->
                        <v-btn
                          icon fab
                          color="info"
                          class="text-right mr-6"
                          @click="showDetails(i)"
                        >
                          <v-icon color="info">mdi-information-box</v-icon>
                        </v-btn>                        
                        <v-switch
                          v-model="i.active"
                          color="info"
                          :readonly="i.editable==false"
                          :disabled="i.bookable==false"
                        ></v-switch>                                           
                      </div>
                    </v-col>                    
                    <!--
                    <v-col class="d-flex justify-end">
                      <v-btn fab icon @click="videoId=i.videoId;dialog_video=true" v-if="i.videoId">
                        <v-icon color="info">mdi-video-box</v-icon>
                      </v-btn>
                      
                      <v-btn
                        icon fab
                        color="info"
                        class="text-center"
                        @click="i.more=true"
                      >
                        <v-icon color="info">mdi-dots-horizontal</v-icon>
                      </v-btn> 
                                           
                    </v-col>                    
                    -->
                    <v-expand-transition>
                      <v-card
                        v-if="i.more"
                        class="transition-fast-in-fast-out v-card--reveal"
                        style="height: 100%;"
                      >
                        <v-card-text class="pb-0">
                          <p class="text-h4 text--primary">
                            Dettagli
                          </p>
                          <p>{{i.details}}</p>
                        </v-card-text>
                        <v-card-actions class="pt-0">
                          <v-btn
                            text
                            class="text-center"
                            color="teal accent-4"
                            @click="i.more=false"
                          >
                            Chiudi
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-expand-transition>
                  </v-row>
                </v-card>       
              </v-col>
            </v-row>
          </div>
        </v-card>
        <v-card class="neu-glow pa-4 mt-8">
          <v-btn-toggle
            v-model="selectedDuration"
            group
            mandatory
            active-class="info"
            width="100%"
            style="display:inherit"
          >
            <v-row>
              <v-col cols="12" md="8">
                <v-row>
                    <v-col cols="12" :md="12/durations.length" v-for="(d,di) in durations" :key="di">
                      <v-card class="neu-glow pa-4">
                        <v-card-title class="d-flex justify-center">
                          {{di==0?'Rinnovo Mensile':'Rinnova per '+durations[di]+' Mesi'}}
                        </v-card-title>
                        <v-card-text class="text-center text-h4">
                          {{(items.filter(i => i.active).reduce((n, {price}) => n + price, 0)*(durations[di])*(1-(discountRates[di]/100))).toFixed(2)}} €
                        </v-card-text>
                        <v-card-text class="text-center warning--text">
                          {{di==0?'Utilizzalo senza Rischi':(di==1?'Sconto '+discountRates[di]+' %':'Blocca il Prezzo')}}
                        </v-card-text>
                        <v-card-text class="text-center">
                          <v-btn :value="di">
                            {{di==0?durations[di]+' Mese':durations[di]+' Mesi'}}
                          </v-btn>
                        </v-card-text>
                      </v-card>
                    </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="4">
                <v-row>
                  <!--
                  <v-col cols="12" md="12" lg="6">
                    <v-card class="neu-glow pa-4"  style="height:317px">
                      <v-card-title class="text-center">
                      Inserisci codice Sconto
                      <br>                      
                      </v-card-title>
                      <v-text-field
                        v-model="discountCode"
                        label="Codice Sconto"
                        append-icon="mdi-percent"
                        outlined
                        color="info"
                        hide-detail
                      ></v-text-field>
                      <p class="text-h6 text-center" v-if="discountCode=='OK'">
                        Fantastico! puoi usufruire di un ulteriore sconto di {{discountCodeValue.toFixed(2)}} a te riservato!
                      </p>
                  </v-col>
                  -->
                  <v-col cols="12" md="12" lg="12">
                    <v-card class="neu-glow pa-2" v-if="items.length">
                      <v-card-text class="text-justify pb-1" v-if="items[0].payWithPaypal&&selectedDuration==0">
                        <p>Stai pagando <strong class="info--text">{{(amountToPay()*1.22).toFixed(2)}} € </strong> ({{amountToPay().toFixed(2)}} + {{(amountToPay()*.22).toFixed(2)}} IVA) per i soli canoni fissi dei moduli sopra indicati</p>
                        <p>I costi variabili verranno fatturati ogni fine mese sulla base dei consumi effettivi.</p>
                        
                        <p class="mt-3 text-center" v-if="!ppLoaded">
                          <v-btn @click="setLoaded(20)" color="info">Procedi</v-btn>
                        </p>
                        
                        <div
                          style="width:100%"
                          class=""
                          ref="paypal_div"
                        ></div>
                      </v-card-text>
                      <v-card-text class="text-justify pb-1" v-else>
                        <p>Stai pagando <strong class="info--text">{{(amountToPay()*1.22).toFixed(2)}} € </strong> ({{amountToPay().toFixed(2)}} + {{(amountToPay()*.22).toFixed(2)}} IVA) per i soli canoni fissi dei moduli sopra indicati
                        <br/>I costi variabili verranno fatturati ogni fine mese sulla base dei consumi effettivi.</p>
                        <v-card class="neu-glow pa-4 ma-3">
                          <v-card-title class="pt-0">
                          Esegui Bonifico Bancario a favore di:
                          </v-card-title>
                          <v-card-text class="info--text">
                            Levante Servizi Sas
                            <br> IBAN: IT 92 G 08340 11400 00000 21097 77
                            <br> Importo: {{(amountToPay()*1.22).toFixed(2)}} € 
                            <br> Causale: {{settings.options.brand}} 
                          </v-card-text>
                        </v-card>                        
                      </v-card-text>                      
                    </v-card>
                  </v-col>
                </v-row>                  
              </v-col>
            </v-row>
          </v-btn-toggle>          
        </v-card>
    </div>
    <v-dialog v-model="dialog_details" max-width="800" v-if="selectedProduct">
      <v-card class="neu-glow mb-3">
        <v-card-title class="text-h5 mb-3"
        >
          Presentazione
          <v-spacer></v-spacer>
          <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_details= false">
                  <v-icon color="info">mdi-close</v-icon>
              </v-btn>
              </template>
              <span>Chiudi</span>
          </v-tooltip>               
        </v-card-title>
        <v-card-text>
          <p class="neu-glow pa-4">{{selectedProduct.details}}</p>
        </v-card-text>
        <v-divider class="py-3" v-if="servicesCosts.some(c=>{return selectedProduct[c.costId]>0})"></v-divider>
        <v-card-text class="pb-4" v-if="servicesCosts.some(c=>{return selectedProduct[c.costId]>0})">
          <v-card class="neu-glow pa-4">
            <p class="text-h5 ">
              Costi a consumo
            </p>
            <p>Oltre al canone mensile vengono addebitati mensilmente i seguenti costi:</p>
            <template v-for="(c,ci) in servicesCosts">
              <div v-if="selectedProduct[c.costId]>0" :key="ci" class="mb-6 px-4">
                <v-row class="px-3 mt-6 neu-glow">
                  <v-col class="text-left ">{{c.name}}</v-col>
                  <v-col class="text-right col-auto">{{selectedProduct[c.costId]}} €</v-col>
                  <v-col class="text-left ">{{c.um}}</v-col>
                </v-row>
              </div>
            </template>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>    
    <v-dialog v-model="dialog_simulator" max-width="1200">
        <v-card class="neu-glow pa-4">
            <v-card-title class="text-h5 mb-3"
            >
              Simulatore Costi Variabili
              <v-spacer></v-spacer>
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_simulator= false">
                      <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                  </template>
                  <span>Esci</span>
              </v-tooltip>                
            </v-card-title>
            <v-card-text>
              Oltre ai canoni mensili, fissi per tutti, vi sono i costi per l'utilizzo di servizi esterni quali Segreteria telefonica e messaggi WhatsApp/SMS.
              Relativamente alla segreteria telefonica i costi sono:
              <ul>
                <li>Durata Totale delle chiamate Ricevute</li>
                <li>Lunghezza totale dei testi letti dall'AI</li>
                <li>Durata Totale delle chiamate Inoltrate (soprattutto se a numero mobile)</li>
              </ul>
              <p>Per quanto riguarda invece i messaggi WhatsApp, il costo varia in funzione della nazione di destinazione e dalla tipologia di messaggio inviato:
                i messaggi per la gestione della prenotazione hanno un costo, quelli di marketing circa il doppio
              </p>
              <p>
                Questo simulatore, consente di stimare i costi variabili in funzione dei principali parametri.
              </p>
            </v-card-text>
            <v-card class="neu-glow pa-4">
              <v-row class="mx-5">
                  <v-col cols="4">
                    <div>Numero Coperti/mese</div>
                    <v-slider
                      class="mt-16"
                      color="info"
                      v-model="form.covers"
                      label=""
                      :max="10000"
                      :step="500"
                      :min="1000"
                      thumb-label="always"
                      :thumb-size="45"
                    ></v-slider>
                  </v-col>
                  <v-col cols="4">
                    <div>Media Coperti per ogni prenotazione</div>
                    <v-slider
                      class="mt-16"
                      color="info"
                      v-model="form.coversPerBooking"
                      label=""
                      :max="10"
                      :step=".1"
                      :min="1"
                      thumb-label="always"
                      :thumb-size="45"
                    ></v-slider>
                  </v-col>                  
                  <v-col cols="4">
                    <div>% coperti prenotati su totale Coperti/mese</div>
                    <v-slider
                      class="mt-16"
                      color="info"
                      v-model="form.bookedpcent"
                      label=""
                      :max="100"
                      :min="0"
                      thumb-label="always"
                      :thumb-size="45"
                    >
                      <template v-slot:thumb-label="{ value }">
                        {{ value + '%' }}
                      </template>                    
                    </v-slider>
                  </v-col>
                  <!--      
                  <v-col cols="6">
                    <div>Utilizza Segreteria Telefonica</div>
                    <v-switch
                      class="mt-16"
                      v-model="form.useVoicemail"
                      inset
                      :label="form.useVoicemail?'SI':'NO'"
                      thumb-label="always"
                    ></v-switch>                  
                  </v-col>
                  -->
                  
                  <v-col cols="4">
                    <div>% Trasferimento Chiamata</div>
                    <v-slider
                      class="mt-16"
                      color="info"
                      v-model="form.forwardpcent"
                      label=""
                      :max="100"
                      :min="0"
                      thumb-label="always"
                      :thumb-size="45"
                    >
                      <template v-slot:thumb-label="{ value }">
                        {{ value + '%' }}
                      </template>  
                    </v-slider>                 
                  </v-col> 
                  <v-col cols="4">
                    <div>Trasferimento su Fisso/Cellulare</div>
                    <v-switch
                      color="info"
                      class="mt-8 ml-16 pl-8"
                      v-model="form.forwardToMobile"
                      inset
                      :label="form.forwardToMobile?'Cellulare':'Fisso'"
                    ></v-switch>                  
                  </v-col>                    
                  <v-col cols="4">
                    <div>% Invio Promemoria</div>
                    <v-slider
                      class="mt-16"
                      color="info"
                      v-model="form.sendReminderpcent"
                      label=""
                      :max="100"
                      :min="0"
                      thumb-label="always"
                      :thumb-size="45"
                    >
                      <template v-slot:thumb-label="{ value }">
                        {{ value + '%' }}
                      </template>                      
                    </v-slider>                 
                  </v-col>  
                  <v-col cols="4">
                    <div>% invio richiesta Recensione</div>
                    <v-slider
                      class="mt-16"
                      color="info"
                      v-model="form.sendReviewRequestpcent"
                      label=""
                      :max="100"
                      :min="0"
                      thumb-label="always"
                      :thumb-size="45"
                    >
                      <template v-slot:thumb-label="{ value }">
                        {{ value + '%' }}
                      </template>                      
                    </v-slider>                                      
                  </v-col> 
                  <v-col cols="8" class="text-center">
                    <v-card class="neu-glow py-8 d-flex align-center justify-center">

                      <div class="text-h5">
                        Costo Mensile Indicativo: {{TotalCosts().toFixed(2)}} €
                      </div>                      
                    </v-card>
                  </v-col>                                                
              </v-row>
            </v-card>
        </v-card>
    </v-dialog>   
    <v-dialog v-model="dialog_video" max-width="800">
      <v-card class="neu-glow mb-3">
        <v-card-title class="text-h5 mb-3"
        >
          Presentazione
          <v-spacer></v-spacer>
          <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_video= false">
                  <v-icon color="info">mdi-close</v-icon>
              </v-btn>
              </template>
              <span>Chiudi</span>
          </v-tooltip>               
        </v-card-title>
        <v-row class="mx-5 neu-glow mt-2">
            <v-col cols="12">
              <div style="padding:56.25% 0 0 0;position:relative;">
                <iframe :src="'https://player.vimeo.com/video/'+ videoId + '?badge=0&amp;autopause=0&amp;quality_selector=1&amp;progress_bar=1&amp;player_id=0&amp;app_id=58479'" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" style="position:absolute;top:0;left:0;width:100%;height:100%;" title="iBookRestaurant_v2"></iframe>
              </div>
            </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_instruction" max-width="800">
        <v-card>
            <v-card-title class="text-h5 mb-3"
            >
              Istruzioni
            </v-card-title>
            <v-row class="mx-5">
                <v-col md="6" cols="12">
                    <p>
                        Per ogni Slot di ogni giorno e di ogni Posizione, è possibile impostre:
                        <ul>
                          <li>
                            Il numero massimo di Coperti prenotabili direttamente dal Cliente
                          </li>
                          <li>
                            Il numero massimo di Tavoli prenotabili direttamente dal Cliente
                          </li>
                          <li>
                            Il numero massimo di tavoli da 1, 2 e 3 Coperti prenotabili direttamente dal Cliente (richiede vengano inserite le capienze minime e massime di ogni tavolo)
                          </li>
                          <li>
                            La durata dello slot, ovvero per quanto tempo il cliente può impegnare il tavolo
                          </li>
                          <li>
                            La somma richiesta, per ogni coperto, per accettare la prenotazione - ad esempio capodanno - (richiede account PayPal)
                          </li>
                        </ul>
                    </p>
                </v-col>
                <v-col md="6" cols="12">
                    <p>
                      Il pulsante 'Salva' si attiva qualora rilevi differenze rispetto ai dati memorizzati.
                    </p>
                    <p>
                      Dopo il salvataggio i dati vengono automaticamente ricaricati: qualora notaste delle incongruenze, prima di fare ulteriori modifiche cliccare sul tasto 'Refresh'
                    </p>
                </v-col>
                <v-col cols="12">
                    <p color="error">
                        <strong>Attenzione:</strong> Questi vingoli valgono solo per le prenotazioni dirette da parte dei clienti. L'operatore può accettare qualsiasi prenotazione
                    </p>
                </v-col>
            </v-row>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary"  @click="dialog_instruction = false">
                OK
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_paypal" max-width="400">
      <v-card class="neu-glow" v-if="ppPaid">
        <v-card-title class="text-h6 font-weight-bold ">
          {{$t(page+'.Payment Successful')}}!
          <v-spacer></v-spacer>
          <v-tooltip top class="ml-3">
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow"  @click="noRetryBtn()">
                <v-icon color="info">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>{{$t(page+'.Close')}}</span>
          </v-tooltip>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-card class="neu-glow pa-4 mt-4">
            <v-img
              contain
              height="400"
              src="/static/ob-animated-isometric/online-transactions-animate.svg"
              lazy-src="/static/ob-animated-isometric/online-transactions-animate.svg"
            ></v-img>
            <div class="display-1 pb-6 font-weight-bold text-center">{{$t(page+'.Thank You')}}!</div>
          </v-card>
        </v-card-text>
      </v-card>
      <v-card class="neu-glow" v-else-if="ppCancel">
        <v-card-title class="text-h6 font-weight-bold ">
          {{$t(page+'.Payment Cancelled')}}!
          <v-spacer></v-spacer>
          <!--
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow"  @click="retryBtn()">
                <v-icon color="success">mdi-repeat</v-icon>
              </v-btn>
            </template>
            <span>{{$t(page+'.Retry')}}</span>
          </v-tooltip>
          -->
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow ml-3"  @click="noRetryBtn()">
                <v-icon color="info">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>{{$t(page+'.Close')}}</span>
          </v-tooltip>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-card class="neu-glow pa-4 mt-4">
            <v-img
              contain
              height="400"
              src="/static/ob-animated-isometric/cancel-animate.svg"
              lazy-src="/static/ob-animated-isometric/cancel-animate.svg"
            ></v-img>
          </v-card>
        </v-card-text>
      </v-card> 
      <v-card class="neu-glow" v-else-if="ppError">
        <v-card-title class="text-h6 font-weight-bold ">
          {{$t(page+'.Payment Error')}}!
          <div v-if="error_message">{{error_message}}</div>
          <v-spacer></v-spacer>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow"  @click="retryBtn()">
                <v-icon color="success">mdi-repeat</v-icon>
              </v-btn>
            </template>
            <span>{{$t(page+'.Retry')}}</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow ml-3"  @click="noRetryBtn()">
                <v-icon color="info">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>{{$t(page+'.Close')}}</span>
          </v-tooltip>
        </v-card-title>
        <v-divider></v-divider>
          <v-card-text>
            <v-card class="neu-glow pa-4 mt-4">
              <v-img
                contain
                height="400"
                src="/static/ob-animated-isometric/503-error-service-unavailable-animate.svg"
                lazy-src="/static/ob-animated-isometric/503-error-service-unavailable-animate.svg"
              ></v-img>
            </v-card>
          </v-card-text>
      </v-card>
    </v-dialog>        
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { loadScript } from "@paypal/paypal-js";
//import _ from 'lodash'
export default {
  data() {
    return {
      page: "Settings",
      loading:false,
      loading_update:false,
      wHeight: window.innerHeight,
      wWidth: window.innerWidth,
      dialog_editOption:false,
      dialog_instruction:false,
      dialog_simulator:false,
      dialog_video:false,
      dialog_details:null,
      videoId:null,
      selectedProduct:null,
      items:[],
      form:{covers:null,bookedpcent:null,useVoicemail:false,forwardpcent:null,forwardToMobile:false,sendReminderpcent:null,sendReviewRequestpcent:null},
      items_hash:null,
      editedOption:null,
      loading_refresh:false,
      durations:[1,12,24],
      discountRates:[0,10,10],
      selectedDuration:1,
      //amountToPay:756,
      discountCode:null,
      discountCodeValue:260,
      paypal:null,
      dialog_paypal:false,
      ppLoaded:null,
      reveal:null,
      servicesCosts:[
                      {"costId":"forwardPrice","name":"Trasferimento Chiamate su Fisso","um":"al minuto"},
                      {"costId":"forwardMobilePrice","name":"Trasferimento Chiamate su Cellulare","um":"al minuto"},
                      {"costId":"TTSPrice","name":"Conversione Testo => Parlato","um":"per 1000 Caratteri"},
                      {"costId":"WAUtilityMessagePrice","name":"Messaggi WhatsApp Utility","um":"per Conversazione"},
                      {"costId":"WAMarketingMessagePrice","name":"Messaggi WhatsApp Marketing","um":"per Conversazione"}],
      headers: [
                //{text: 'N', align: 'start', value: 'new'},
                { text: 'Modulo',         value: 'name',          align: 'start',    sortable: false, class:'px-1 text-lg-button' },
                { text: 'Scadenza',       value: 'expiryDate',    align: 'start',    sortable: false, class:'px-1 text-lg-button' },
                { text: 'Funzione',       value: 'description',   align: 'start',    sortable: false, class:'px-1 text-lg-button' },
                { text: 'Canone Fisso ',  value: 'price',         align: 'start',    sortable: false, class:'px-1 text-lg-button' },
                { text: 'Messaggio',      value: 'messageCost',   align: 'center',   sortable: false, class:'px-1 text-lg-button' },
                { text: 'Trasf.',         value: 'forwardCost',   align: 'center',   sortable: false, class:'px-1 text-lg-button' },
                { text: 'TTS',            value: 'TTSCost',       align: 'center',   sortable: false, class:'px-1 text-lg-button' },
                { text: 'Attiva',         value: 'active',        align: 'center',   sortable: false, class:'px-1 text-lg-button' },
              ],
              iBookSizes:[{type:"S",price:99},{type:"M",price:119},{type:"L",price:139}]  
    };
  },
  computed : {
    ...mapGetters(["settings"]),

  },
  beforeUnmount()
  {
      alert("leaving")
  },
  created(){
    this.getData()

    //console.log(716,this.user);
    /*
    if (this.user&&this.user.username=='')
    {
      this.$router.push('/auth/login').catch(() => {});
    }
    else
    {
      this.getData()
    }*/
  },
  mounted(){
    //console.log(768,this.$route.query.user)
    //this.setLoaded(20)
  },
  watch : {
    item (newValue) {
      console.log(789,newValue)
      //this.getData(newValue)
    },
    discountCode(newValue)
    {
      console.log(608,newValue);
      this.amountToPay();
      //this.setLoaded(20)
    },
    assignedTable(newValue)
    {
      console.log(794,newValue)
      //this.assignedTables.push(newValue);
      console.log(796,newValue,this.assignedTables)
      this.assignTables(newValue);
    }
  },
  methods:
  {
    showDetails(i)
    {
      console.log(831,i)
      this.selectedProduct=i;
      this.dialog_details=true;
    },
    TotalCosts()
    {
      console.log(586,this.settings);
      var f=this.form;
      //var coversPerBooking=2.3;
      var waMsgCost=0.04;
      var pbxTransferMobile=0.06;
      var pbxTransfer=0.00;
      var pbxCallCost=0.01;
      var basicPbxCosts=f.covers*f.bookedpcent/100*pbxCallCost/f.coversPerBooking
      console.log('pbx',basicPbxCosts);
      var forwardCosts=f.forwardToMobile?f.forwardpcent/100*pbxTransferMobile*f.covers*f.bookedpcent/100/f.coversPerBooking:f.forwardpcent/100*pbxTransfer*f.covers*f.bookedpcent/100/f.coversPerBooking;
      console.log('fwd',forwardCosts);
      var basicWACosts=f.covers*f.bookedpcent/100*waMsgCost/f.coversPerBooking;
      console.log('wa',basicWACosts);
      var reminderCosts=basicWACosts*f.sendReminderpcent/100*.5;
      console.log('rm',reminderCosts);
      var reviewRequestCosts=basicWACosts*f.sendReviewRequestpcent/100;
      console.log('rw',reviewRequestCosts);
      var totalCosts=basicPbxCosts+forwardCosts+basicWACosts+Math.max(reminderCosts,reviewRequestCosts);
      console.log('tot',totalCosts,f)
      return totalCosts;
    },
    amountToPay()
    {
      var discount=this.discountCode=='Oas09fasjhfaK'?this.discountCodeValue:0;
              // this.items.filter(i => i.active).reduce((n, {price, discountSize, discountFF}) => n + price - discountSize - discountFF, 0))*(1-(discountRates[di]/100))).toFixed(2)
        return this.items.filter(i => i.active).reduce((n, {price}) => n + price , 0)*(this.durations[this.selectedDuration])*(1-(this.discountRates[this.selectedDuration]/100)) - discount;
    },
    retryBtn: function () 
    {
      console.log("379");
      this.$refs.paypal_div='';
      this.dialog_paypal = false;
      this.ppError = false;
      this.ppCancel = false;     
      //this.setLoaded(20);
    },
    noRetryBtn: function () 
    {
      console.log("379");
      this.dialog_paypal = false;
      this.ppError = false;
      this.ppCancel = false;
      this.$refs.paypal_div='';
      this.dialog_paypal=false
      //this.setLoaded(20);
    },
    async setLoaded (slot)
    {
      console.log(665,slot)
      this.ppLoaded = true;
      this.dialog_paypal = false;
      //console.log(1831,this.booking.covers)
      //console.log(1832,(parseFloat(this.freeTables.find(t=>t.slotId==slot.slotId).prepayment)*parseInt(this.booking.covers)).toFixed(2))
      //var paypal=null;
      var amount=this.amountToPay().toFixed(2)
      var description='Fixed Fees Modules';//'Cauzione per ' + this.booking.covers +' Ospiti';
      var brand='iBook';//this.settings.userid;
      var paypalIntent='CAPTURE';//this.settings.options.paypalIntent
      var license=null;//var discount=this.discountCode=='OK'?this.discountCodeValue:0;
      var amountTP= this.items.filter(i => i.active).reduce((n, {price}) => n + price, 0)*(this.durations[this.selectedDuration])*(1-(this.discountRates[this.selectedDuration]/100));// - (this.discountCode=='OK'?this.discountCodeValue:0);
      if (this.items)
      {
         license=this.items.filter(l=>l.active===true&&l.bookable===true).map(l=>l.license).reduce((a,b)=>a+b,0);
      }
      console.log(1835,amount,description,this.amountToPay())
      var referenceId= JSON.stringify({'userid':this.settings.userid,'duration':this.durations[this.selectedDuration],'modules':license,'amountToPay':amountTP});//this.utf8_to_b64(this.booking.date+'|'+this.booking.covers+'|'+this.booking.phone);
      console.log(682,referenceId);
      //var brand=this.settings.brand;
      //https://developer.paypal.com/sdk/js/reference/
      //https://developer.paypal.com/docs/api/orders/v2/#orders_create
      //https://www.paypal-community.com/t5/Payments-Archives/How-does-the-quot-Honor-Period-quot-for-authorizations/m-p/2773046
      //https://paypal.github.io/PayPal-PHP-SDK/sample/doc/payments/Reauthorization.html
      var opts={
              style: {
                layout: "vertical",
                color: "blue",
                shape: "rect",
                label: "pay"
              },
              createOrder: function(data, actions) 
              {
                return actions.order.create(
                {
                  "purchase_units": 
                  [{
                    "reference_id": referenceId,
                    "description": description,
                    "amount": {
                      "currency_code": "EUR",
                      "value": amount
                    }
                  }],
                  "intent":paypalIntent,
                  "application_context":
                  {
                    "brand_name": brand,
                    "shipping_preference": "NO_SHIPPING"
                  }   
                });
              },
            /*
            createSubscription: (data, actions) => {
              if (this.settings.subscription_id) 
              {
                console.log('shop_644',this.user.subscription_id,this.selected_plan.plan_id);
                
                if (this.user.subscription_status=='SUSPENDED')
                {
                  return actions.subscription.activate(this.user.subscription_id, {
                    reason: "Reactivated by customer"
                  });
                }
                else
                {  
                  return actions.subscription.revise(this.user.subscription_id, {
                    plan_id: this.selected_plan.plan_id
                  });
                }
              }
              else 
              {
                return actions.subscription.create({
                  plan_id: this.selected_plan.plan_id,
                  start_time: this.user.subscription_start,
                });
              }
            },
            //3421575838
            */
            onApprove: async (data, actions) => {
              console.log(1788, data,actions);
              console.log(1886,data.orderId)
              
              //this.booking.prepaidAmount=amount;
              this.ppPaid=true;
              this.dialog_paypal=true;
              console.log(1889,this.booking)
              if (data.orderID) {
                //this.$store.dispatch("setCredits",this.user.credits);
                //update database
                this.booking.payPalOrderId=data.orderID,
                data.bookingDate=this.booking.date;
                data.lastName=this.booking.lastName;
                data.customerId=this.booking.customerId;
                data.phone=this.booking.countryCode+this.booking.phone;
                data.amount=amount;
                data.paypalIntent=this.settings.options.paypalIntent
                this.savePayPalPayment(data);
              }
            },
            onCancel: (data) => {
              this.ppCancel = true;
              this.dialog_paypal=true;
              console.log("ppcancel", data);
            },
            onError: (err) => {
              console.log("error", err);
              this.dialog_paypal=true
              //let err_details=err.details;
              //this.error_message='Error: '+err_details.description;
              //console.log(this.error_message);
              let err_string=JSON.stringify(err);
              console.log(1802,err_string);
              //console.log(err.substr(0,30))
              console.log("erore:", err);
              this.ppError = true;

              console.log(1809,err.details.description);
            },
          };
      console.log(1916, this.ppLoaded,this.settings.options.paypalClientId);
      

      this.paypal = await loadScript({ "client-id": this.settings.options.paypalClientId, "currency": "EUR","disable-funding":"credit,card","intent":this.settings.options.paypalIntent.toLowerCase()});
      if (paypal) {
          try {
              await this.paypal.Buttons(opts).render(this.$refs.paypal_div);
          } catch (error) {
              console.error("failed to render the PayPal Buttons:", error);
          }
      }
    },
    async savePayPalPayment(data)
    {
      console.log(1949, data);
      try {
        const payload=JSON.stringify({"action":"PayPalPaymentUser_set","payload":data});
        const res = await this.$http.post('/shop/shop.php', payload );
        console.log(1953,payload);
        let pl=res.data.payload;
        console.log(719,pl)
        switch (res.data.errorid) {
          case "0":
            console.log("467", data);
            console.log("468", res.data);
            this.ppPaid = true;
            /*
            setTimeout(() => {
              //this.process();
              this.saveBooking()
            }, 1000);
            */
            /*
            this.user.plan_name=pl.name;
            this.user.planlevel=pl.planlevel
            this.user.next_billing_time=pl.next_billing_time;
            this.user.missinginvoicedata=0*/
            break;
          case "0007":
            this.$router.push("/auth/login").catch(() => {});
            break;
        }
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },    
    itemClass(item)
    {
      var clr=!item.bookable?'blue-grey darken-3':'';
      return clr;
    },    
    editOption(f)
    {
      this.editedOption=f;
      console.log(214,f)
      this.dialog_editOption=true;
    },
    async saveOption(a)
    {
        console.log(144,this.editedOption);
        this.loading_update=true;
        console.log(255,this.form);
        var action='';
        if(a=='delete')
        {
          action='unsetOption'
          //f.active=0;
        }
        else
        {
          action='saveOption';
        }
        let payload={"action":action,"payload":JSON.stringify(this.editedOption)};
        console.log(257,payload)
        let w= await this.updateDB(payload)
        this.loading_update=false;
        console.log(260,w);
        if(w.errorid=='0')
        {
            this.snackbar_color="success"
            this.message =w.message;
            this.snackbar = true;
            this.dialog_editOption=false;
            //this.slotsByDOW_hash=JSON.stringify(this.slotsByDOW);
        }   
    },
    async saveItems()
    {
        this.loading_update=true;
        console.log(255,this.form);
        var license=this.items.filter(l=>l.active===true&&l.bookable===true).map(l=>l.license).reduce((a,b)=>a+b,0);
        let payload={"action":"saveItem","table":"License","payload":license};
        console.log(257,payload)
        let w= await this.updateDB(payload)
        this.loading_update=false;
        console.log(260,w);
        if(w.errorid=='0')
        {
            this.snackbar_color="success"
            this.message =w.message;
            this.snackbar = true;
             this.getData();
        }   
    },    
    async getData(origin)
    {
        {
            if(origin=='refresh')
            {
              this.loading_refresh=true;
            }
            else
            {
              this.loading=true;
            }
            try{
                const payload=JSON.stringify({"date": this.date,"action":"AllProducts_get"});
                const res = await this.$http.post('/settings/settings.php', payload );
                console.log(275,res);
                this.loading_refresh=false;
                this.loading=false;
                switch (res.data.errorid)
                {
                  case '0':
                      sessionStorage.setItem('jwt', res.data.jwt);
                      this.items=res.data.payloads.allProducts;
                      this.reveal=Array((res.data.payloads.allProducts).length).fill(false)
                      this.items_hash=JSON.stringify(this.items);
                      console.log(315,this.items)
                      console.log(316,this.reveal)
                  break;
                  case '0006':
                      this.$router.push('/auth/login').catch(() => {});
                  break;
                }
                this.loading= false;
            } catch(e)
            {
                this.loading= false;
                //console.log(res.data);
            }
        }
    },
    async updateDB(payload){
        try{
            const res = await this.$http.post('/settings/settings.php', payload);
            console.log(324,res);
            if (res.data.errorid=='0')
            {
            sessionStorage.setItem('jwt', res.data.jwt);
            this.snackbar_color='success';
            this.snackbar_message=res.data.message;

            if (res.data.message)
            {
                console.log(333);
                //this.snackbar=true;
            }
            }
            else
            {
              this.snackbar_color='error'
              this.snackbar_message=res.data.message;
              this.snackbar=true;
            console.log(342);
            //this.$router.push('/auth/login').catch(() => {});
            }

            //this.$store.dispatch("setUser", res.data.user); 
            return res.data;
        } catch(e)
        {
        console.log(e);
        }
    },
  },
};
</script>

<style>
  .v-card--reveal {
  bottom: 0;
  opacity: 1 !important;
  position: absolute;
  width: 100%;
  }
</style>